import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { connect } from 'react-redux';
import { bookmarksAllQuery } from '../../../queries';
import Section from '../../Section';
import SectionList from '../../SectionList';
import ItemCard from '../../Cards/ItemCard';
import { setError } from '../../../actions';
import SectionPlaceholder from '../../Placeholders/SectionPlaceholder';
import ItemCardPlaceholder from '../../Placeholders/ItemCardPlaceholder';

const mapDispatchToProps = dispatch => {
  return {
    setErrorUI: errorState => dispatch(setError(errorState))
  };
};

const bookmarksVariable = {
  limit: 100
};

const BookmarksPage = ({ setErrorUI }) => {
  const { t } = useTranslation();
  const [itemId, setItemId] = useState(null);
  const setCarousel = id => {
    return itemId === id ? null : setItemId(id);
  };

  const { loading, data, error } = useQuery(bookmarksAllQuery, {
    variables: bookmarksVariable,
    ssr: false,
    fetchPolicy: 'network-only'
  });

  const emptyLayout = (
    <div className="section-list-bookmarks__empty" data-cy="no-bookmarks">
      <Image
        src={'/static/images/favorites.svg'}
        width={152}
        height={280}
        alt="Image"
      />
      <p className="section-list-bookmarks__empty__text">
        {t('pages.bookmarks.no_results')}
      </p>
    </div>
  );
  const bookmarks = data?.bookmarks || [];
  const itemsList =
    bookmarks.length &&
    bookmarks.map(bookmark => (
      <ItemCard
        key={bookmark.item.id}
        {...bookmark.item}
        inBookmarks={true}
        carousel={true}
        itemId={itemId}
        setCarousel={setCarousel}
      />
    ));

  const placeholder = (
    <SectionPlaceholder more={false}>
      <ItemCardPlaceholder />
      <ItemCardPlaceholder />
    </SectionPlaceholder>
  );

  useEffect(() => {
    if (error) setErrorUI(true);
  }, [error]);

  if (loading) return placeholder;

  return (
    <Section
      title={t('pages.bookmarks.title')}
      headlineType="h1"
      sectionAdditionalClasses="section-page"
      listAdditionalClasses="bookmarks"
      noHeader
    >
      <SectionList listAdditionalClasses="section-list-bookmarks">
        {itemsList || emptyLayout}
      </SectionList>
    </Section>
  );
};

BookmarksPage.propTypes = {
  setPageLoader: PropTypes.func,
  setErrorUI: PropTypes.func
};

export default connect(null, mapDispatchToProps)(BookmarksPage);
